import { MultiCheckboxFilterOption } from '../types';
import { MultiSelectCheckbox } from '../../components';

export const config: MultiCheckboxFilterOption = {
  id: 'omicsExplorer.filters.codingEffect',
  title: {
    id: 'omicsExplorer.filters.codingEffect',
    defaultMessage: 'Coding Effect',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'group',
    checkboxOptions: [
      {
        id: 'omicsExplorer.filters.codingEffect.frameshift',
        searchValue: 'frameshift',
        intlLabel: {
          id: 'omicsExplorer.filters.codingEffect.frameshift',
          defaultMessage: 'Frameshift',
        },
      },
      {
        id: 'omicsExplorer.filters.codingEffect.spliceRegion',
        searchValue: 'splice_region',
        intlLabel: {
          id: 'omicsExplorer.filters.codingEffect.spliceRegion',
          defaultMessage: 'Splice region',
        },
      },
      {
        id: 'omicsExplorer.filters.codingEffect.spliceSite',
        searchValue: 'splice_site',
        intlLabel: {
          id: 'omicsExplorer.filters.codingEffect.spliceSite',
          defaultMessage: 'Splice site',
        },
      },
      {
        id: 'omicsExplorer.filters.codingEffect.stopLost',
        searchValue: 'stop_lost',
        intlLabel: {
          id: 'omicsExplorer.filters.codingEffect.stopLost',
          defaultMessage: 'Stop lost',
        },
      },
      {
        id: 'omicsExplorer.filters.codingEffect.startLost',
        searchValue: 'start_lost',
        intlLabel: {
          id: 'omicsExplorer.filters.codingEffect.startLost',
          defaultMessage: 'Start lost',
        },
      },
      {
        id: 'omicsExplorer.filters.codingEffect.nonsense',
        searchValue: 'nonsense',
        intlLabel: {
          id: 'omicsExplorer.filters.codingEffect.nonsense',
          defaultMessage: 'Nonsense',
        },
      },
      {
        id: 'omicsExplorer.filters.codingEffect.inframe',
        searchValue: 'inframe',
        intlLabel: {
          id: 'omicsExplorer.filters.codingEffect.inframe',
          defaultMessage: 'Inframe',
        },
      },
      {
        id: 'omicsExplorer.filters.codingEffect.missense',
        searchValue: 'missense',
        intlLabel: {
          id: 'omicsExplorer.filters.codingEffect.missense',
          defaultMessage: 'Missense',
        },
      },
      {
        id: 'omicsExplorer.filters.codingEffect.UTR3',
        searchValue: 'UTR3',
        intlLabel: {
          id: 'omicsExplorer.filters.codingEffect.UTR3',
          defaultMessage: 'UTR3',
        },
      },
      {
        id: 'omicsExplorer.filters.codingEffect.UTR5',
        searchValue: 'UTR5',
        intlLabel: {
          id: 'omicsExplorer.filters.codingEffect.UTR5',
          defaultMessage: 'UTR5',
        },
      },
      {
        id: 'omicsExplorer.filters.codingEffect.synonymous',
        searchValue: 'synonymous',
        intlLabel: {
          id: 'omicsExplorer.filters.codingEffect.synonymous',
          defaultMessage: 'Synonymous',
        },
      },
    ],
  },
};
